import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

import { classes, palette, breakPoint } from '@mirinae/react-ui';
import IconLongArrow from '@mirinae/explorer/components/assets/icon-right-long-arrow.svg';

export const LoginLayoutWrapper = styled.div`
    @media only screen and (min-width: ${breakPoint.sm}) {
        display: flex;
        justify-content: center;
        gap: 100px;
    }
    .${classes.desktop} & {
        display: flex;
        justify-content: center;
        gap: 100px;
    }
`;

export const LoginLayer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .${classes.desktop} & {
        width: 260px;
    }

    .${classes.mobile} & {
        max-width: 100%;
        width: 260px;
        margin: auto;
        padding: 20px 0;
    }
`;

export const LoginColForms = styled.div`
    position: relative;
    width: 260px;
`;

export const LoginColDiv = styled.div`
    width: 100%;
    height: 12px;
    line-height: 12px;
    margin: 15px 0;
    color: ${palette.point.gray};
    font-size: 10px;
    text-align: center;
    background-image: linear-gradient(to right,
            #d8d8d8 0,
            #d8d8d8 calc(50% - 21px),
            transparent calc(50% - 21px),
            transparent calc(50% + 21px),
            #d8d8d8 calc(50% + 21px),
            #d8d8d8 100%);
    }
    background-size: 100% 1px;
    background-position: 0 50%;
    background-repeat: no-repeat;
`;

export const FormRow = styled.div`
    display: flex;
    flex-direction: column;
    // height: 62px;
    & + & {
        margin-top: 3px;
    }
`;

export const FormLabel = styled.label`
    height: 13px;
    margin-bottom: 2px;
    padding-left: 16px;
    font-size: 11px;
    font-weight: 600;
`;

export const FormWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 20px 0 6px;
    border-radius: 20px;
    background-color: #f9f9f9;

    input {
        width: 100%;
        height: 40px;
        border: none;
        background-color: transparent;
        font-size: 13px;
    }
`;

export const FormIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 30px;
`;

export const FormError = styled.div`
    height: 12px;
    line-height: 12px;
    font-size: 10px;
    color: ${palette.point.orange};
    text-align: center;
`;

export const LoginColBottom = styled.div``;

export const LoginColButtons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 15px;
    margin-top: 6px;
`;

export const LinkForgot = styled(Link)`
    color: #979797;
    font-size: 10px;
    text-decoration: underline;

    @media only screen and (max-width: ${breakPoint.common.md}) {
        font-size: 12px;
        font-weight: 500;
    }
`;

export const LoginColLogin = styled.div`
    padding-top: 15px;
    button {
        width: 200px;
        height: 40px;
        border-radius: 20px;
        font-weight: 600;
        font-size: 15px;
        color: #fff;
        background-color: #87cbc8;
        &:hover {
            background-color: ${palette.green.middle};
        }
        &:disabled {
            background-color: ${palette.gray.light};
        }
    }
`;

export const LoginColLinks = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    font-size: 11px;
    font-weight: 400;
    color: ${palette.point.gray};
    a {
        margin-left: 5px;
        font-size: 12px;
        font-weight: 700;
        color: ${palette.green.middle};
    }
  
    @media only screen and (max-width: ${breakPoint.common.md}) {
        font-size: 12px;
        a {
            font-size: 14px;
        }
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    padding-top: 20px;

    .${classes.desktop} & {
        justify-content: space-between;
        width: 260px;
    }
    .${classes.mobile} & {
        justify-content: space-between;
        width: 100%;
        margin: 0 auto;
    }
`;

export const LoginRightBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 500;
    font-size: 25px;
    line-height: 30px;
    margin-left: 100px;
    gap: 20px;
    // max-width: 310px;
    width: max-content;
    // white-space: nowrap;
    color: ${palette.main.darken[1]};

    @media only screen and (max-width: ${breakPoint.sm}) {
        display: none;
    }
    .${classes.mobile} & {
        display: none;
    }
`;

export const FirstRowMessage = styled.div`
    display: flex;
    flex-direction: column;
    white-space: break-spaces;
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    max-width: 300px;
    color: #48A9A6;
`;
export const SecondRowMessage = styled.div`
    font-weight: 500;
    font-size: 30px;
    line-height: 37px;
    color: #48A9A6;  
  
    strong {
        font-style: italic;
        font-weight: 700;
        font-size: 30px;
        line-height: 37px;        
    }
`;
export const ThirdRowMessage = styled.div` 
    font-size: 16px;
    padding-right: 93px;  
    font-weight: 400;
    line-height: 28px;
    color: #7A7A7A;
    white-space: nowrap;
`;
export const RevertMessage = styled.div` 
    margin-top: 10px;
    display: none;
    font-size: 13px;
    font-weight: 400;
    color: #7A7A7A;
    text-align: center;
    line-height: 150%;
    width: calc(100% + 26px);
    //
    @media only screen and (max-width: ${breakPoint.sm}) {
        display: block;
    }
    .${classes.mobile} & {
        display: block;
    }
`;
